import axios from 'axios';
import {
	ApiEvaluateSingleDriverPayload,
	ApiEvaluateSingleDriverResponse,
	ApiExportRosterCsvPayload,
	ApiExportRosterCsvResponse,
	ApiExportRosterXlsxPayload,
	ApiExportRosterXlsxResponse,
} from '@/rennovation/planning-view/types/api/roster-response';

export class RosterApiService {
	private baseUrl = '/api/roster';

	async evaluateSingleDriver(driverId: string, from: string, to: string, debug = false): Promise<ApiEvaluateSingleDriverResponse> {
		const payload: ApiEvaluateSingleDriverPayload = {
			driver: driverId,
			from,
			to,
			debug,
		};
		const response = await axios.post<ApiEvaluateSingleDriverResponse>(`${this.baseUrl}/evaluateSingleDriver`, payload);
		return response.data;
	}

	async exportRosterCsv(payload: ApiExportRosterCsvPayload): Promise<ApiExportRosterCsvResponse> {
		const response = await axios.post<ApiExportRosterCsvResponse>(`${this.baseUrl}/csv/export`, payload);
		return response.data;
	}

	async exportRosterXlsx(payload: ApiExportRosterXlsxPayload): Promise<ApiExportRosterXlsxResponse> {
		const response = await axios.post<ApiExportRosterXlsxResponse>(`${this.baseUrl}/xlsx/export`, payload, {
			responseType: 'arraybuffer',
		});
		return response.data;
	}
}
